import { SearchInput } from './search-input';
import { h } from 'preact';
import { useFormKeyDownHandler } from '../hooks/use-form-key-down-handler';
export function Form(props) {
    var onKeyDown = useFormKeyDownHandler(props);
    return (h("form", { id: "search-form", onSubmit: props.onSubmit },
        h(SearchInput, { value: props.query, onInput: function (evt) { return props.onChange(evt.target.value); }, onKeyDown: onKeyDown })));
}
